<ng-template #contentHeaderTemplate>
  @if (mode !== EditModeEnum.SHOW) {
    <div class="row">
      <div class="col-12 d-flex justify-content-end ">
        <button class="btn btn-primary" (click)="save()">
          {{ (process?.id ? 'misc.save_btn' : 'misc.create_btn') | translate }}
        </button>
      </div>
    </div>
  }
</ng-template>

@if (process) {
  <app-process-tab-switcher [processId]="process.id"></app-process-tab-switcher>
}

<div class="row g-3">
  @if (mode === EditModeEnum.SHOW && processVersion === undefined) {
    <div class="col-12">
      <div class="card mb-3">
        <div class="card-body">
          {{'authenticated.quality-management.processes.versions.show.no_version_message' | translate }}
        </div>
      </div>
    </div>
  } @else {
    <div class="col-12 col-md-9 order-md-1">
      <form [formGroup]="form" (submit)="save()">
        <div class="card mb-3">
          <div class="card-header">
            {{ 'authenticated.quality-management.processes.edit.header' | translate }}
          </div>
          <div class="card-body">
            <div class="row">

              <div class="col-12 col-lg-6 py-1">
                @if (mode === EditModeEnum.SHOW) {
                  <app-read-only-static
                    label="{{'authenticated.quality-management.processes.edit.form.ext_id.label' | translate}}"
                    [value]="(processVersion?.ext_id ?? process?.ext_id) ?? ''"
                  ></app-read-only-static>
                } @else {
                  <app-form-group
                    [formControl]="form.controls.ext_id"
                    label="{{'authenticated.quality-management.processes.edit.form.ext_id.label' | translate }}"
                    [errorMessages]="{required: ('authenticated.quality-management.processes.edit.form.ext_id.validation_messages.required' | translate)}"
                  ></app-form-group>
                }
              </div>

              <div class="col-12 col-lg-6 py-1">
                @if (mode === EditModeEnum.SHOW) {
                  <app-read-only-static
                    label="{{'authenticated.quality-management.processes.edit.form.title.label' | translate}}"
                    [value]="(processVersion?.title ?? process?.title) ?? ''"
                  ></app-read-only-static>
                } @else {
                  <app-form-group
                    [formControl]="form.controls.title"
                    label="{{'authenticated.quality-management.processes.edit.form.title.label' | translate }}"
                  ></app-form-group>
                }
              </div>

              <div class="col-12 col-lg-6 py-1">
                @if (mode === EditModeEnum.SHOW) {
                  <app-read-only-static
                    label="{{'authenticated.quality-management.processes.edit.form.category.label' | translate}}"
                    [value]="(processVersion?.category ?? process?.category)
                      ? ('enums.processCategoryEnum.' + (processVersion?.category ?? process?.category) | translate)
                      : ''"
                  ></app-read-only-static>
                } @else {
                  <app-multi-select-enum
                    [enum]="ProcessCategoryEnum"
                    [formControl]="form.controls.category"
                    translateKey="processCategoryEnum"
                    [multi]="false"
                    label="{{'authenticated.quality-management.processes.edit.form.category.label' | translate }}"
                  ></app-multi-select-enum>
                }
              </div>

              <div class="col-12 col-lg-6 py-1">
                @if (mode === EditModeEnum.SHOW) {
                  <app-read-only-static
                    label="{{'authenticated.quality-management.processes.edit.form.roles.label' | translate}}"
                    [value]="((processVersion?.roles ?? process?.roles) ?? [] | translateArray:'enums.processRoleEnum.') ?? ''"
                  ></app-read-only-static>
                } @else {
                  <app-multi-select-enum
                    [enum]="ProcessRoleEnum"
                    [formControl]="form.controls.roles"
                    translateKey="processRoleEnum"
                    label="{{'authenticated.quality-management.processes.edit.form.roles.label' | translate }}"
                  ></app-multi-select-enum>
                }
              </div>

              <div class="col-12 py-1">
                @if (mode === EditModeEnum.SHOW) {
                  <app-read-only-static
                    type="textarea"
                    label="{{'authenticated.quality-management.processes.edit.form.description.label' | translate}}"
                    [value]="(processVersion?.description ?? process?.description) ?? ''"
                  ></app-read-only-static>
                } @else {
                  <app-form-group
                    [formControl]="form.controls.description"
                    type="textarea"
                    label="{{'authenticated.quality-management.processes.edit.form.description.label' | translate }}"
                  ></app-form-group>
                }
              </div>

              <div class="col-12 py-1">
                @if (mode === EditModeEnum.SHOW) {
                  <app-read-only-static
                    type="textarea"
                    label="{{'authenticated.quality-management.processes.edit.form.goal.label' | translate}}"
                    [value]="(processVersion?.goal ?? process?.goal) ?? ''"
                  ></app-read-only-static>
                } @else {
                  <app-form-group
                    [formControl]="form.controls.goal"
                    type="textarea"
                    label="{{'authenticated.quality-management.processes.edit.form.goal.label' | translate }}"
                  ></app-form-group>
                }
              </div>

              <div class="col-12 py-1">
                @if (mode === EditModeEnum.SHOW) {
                  <app-read-only-static
                    label="{{'authenticated.quality-management.processes.edit.form.scope.label' | translate}}"
                    [value]="(processVersion?.scope ?? process?.scope) ?? ''"
                  ></app-read-only-static>
                } @else {
                  <app-form-group
                    [formControl]="form.controls.scope"
                    label="{{'authenticated.quality-management.processes.edit.form.scope.label' | translate }}"
                  ></app-form-group>
                }
              </div>

              <div class="col-12 col-lg-6 py-1">
                @if (mode === EditModeEnum.SHOW) {
                  <app-read-only-static
                    label="{{'authenticated.quality-management.processes.edit.form.priority.label' | translate}}"
                    [value]="(processVersion?.priority ?? process?.priority)
                      ? ('enums.processPriorityEnum.' + (processVersion?.priority ?? process?.priority) | translate)
                      : ''"
                  ></app-read-only-static>
                } @else {
                  <app-multi-select-enum
                    [enum]="ProcessPriorityEnum"
                    [formControl]="form.controls.priority"
                    translateKey="processPriorityEnum"
                    [multi]="false"
                    label="{{'authenticated.quality-management.processes.edit.form.priority.label' | translate }}"
                  ></app-multi-select-enum>
                }
              </div>

              <div class="col-12 col-lg-6 py-1">
                @if (mode === EditModeEnum.SHOW) {
                  <app-read-only-static
                    label="{{'authenticated.quality-management.processes.edit.form.complexity.label' | translate}}"
                    [value]="(processVersion?.complexity ?? process?.complexity)
                      ? ('enums.processComplexityEnum.' + (processVersion?.complexity ?? process?.complexity) | translate)
                      : ''"
                  ></app-read-only-static>
                } @else {
                  <app-multi-select-enum
                    [enum]="ProcessComplexityEnum"
                    [formControl]="form.controls.complexity"
                    translateKey="processComplexityEnum"
                    [multi]="false"
                    label="{{'authenticated.quality-management.processes.edit.form.complexity.label' | translate }}"
                  ></app-multi-select-enum>
                }
              </div>

              <div class="col-12 col-lg-6 py-1">
                @if (mode === EditModeEnum.SHOW) {
                  <app-read-only-static
                    label="{{'authenticated.quality-management.processes.edit.form.owner_id.label' | translate}}"
                    [value]="(processVersion?.owner?.name ?? process?.owner?.name) ?? ''"
                  ></app-read-only-static>
                } @else {
                  <app-multi-select-with-service-list
                    [service]="userService"
                    [searchOnField]="'name'"
                    [formControl]="form.controls.owner_id"
                    label="{{'authenticated.quality-management.processes.edit.form.owner_id.label' | translate }}"
                    [sort]="'-created_at'"
                    [selectionMode]="'single_id'"
                  ></app-multi-select-with-service-list>
                }
              </div>

              <div class="col-12 col-lg-6 py-1">
                @if (mode === EditModeEnum.SHOW) {
                  <app-read-only-static
                    label="{{'authenticated.quality-management.processes.edit.form.review_cycle.label' | translate}}"
                    [value]="(processVersion?.review_cycle ?? process?.review_cycle) ?? ''"
                  ></app-read-only-static>
                } @else {
                  <app-form-group
                    [formControl]="form.controls.review_cycle"
                    label="{{'authenticated.quality-management.processes.edit.form.review_cycle.label' | translate }}"
                    [errorMessages]="{
                    pattern: ('authenticated.quality-management.processes.edit.form.review_cycle.validation_messages.pattern' | translate),
                    min: ('authenticated.quality-management.processes.edit.form.review_cycle.validation_messages.min' | translate),
                  }"
                  ></app-form-group>
                }
              </div>

              <div class="col-12 col-lg-6 py-1">
                @if (mode === EditModeEnum.SHOW) {
                  <app-read-only-static
                    type="textarea"
                    label="{{'authenticated.quality-management.processes.edit.form.input.label' | translate}}"
                    [value]="(processVersion?.input ?? process?.input) ?? ''"
                  ></app-read-only-static>
                } @else {
                  <app-form-group
                    [formControl]="form.controls.input"
                    type="textarea"
                    label="{{'authenticated.quality-management.processes.edit.form.input.label' | translate }}"
                  ></app-form-group>
                }
              </div>

              <div class="col-12 col-lg-6 py-1">
                @if (mode === EditModeEnum.SHOW) {
                  <app-read-only-static
                    type="textarea"
                    label="{{'authenticated.quality-management.processes.edit.form.output.label' | translate}}"
                    [value]="(processVersion?.output ?? process?.output) ?? ''"
                  ></app-read-only-static>
                } @else {
                  <app-form-group
                    [formControl]="form.controls.output"
                    type="textarea"
                    label="{{'authenticated.quality-management.processes.edit.form.output.label' | translate }}"
                  ></app-form-group>
                }
              </div>

            </div>
          </div>
        </div>
      </form>

      @if (process) {
        <app-authenticated-quality-management-processes-sub-processes
          [process]="process"
          [processVersion]="processVersion"
        ></app-authenticated-quality-management-processes-sub-processes>

        <app-authenticated-quality-management-processes-documents
          [process]="process"
          [processVersion]="processVersion"
        ></app-authenticated-quality-management-processes-documents>
      }
    </div>

    <div class="col-12 col-md-3 order-md-2">
      @if (process) {
        <div class="card mb-3">
          <div class="card-header">
            {{ 'authenticated.quality-management.processes.edit.version_card.header' | translate }}
          </div>
          <form [formGroup]="publishVersionForm" (submit)="publishVersion()" class="card-body d-grid gap-2">

            <app-read-only-static
              [value]="versionNumber"
              label="{{'authenticated.quality-management.processes.edit.version_card.form.version_number.label' | translate }}"
            ></app-read-only-static>

            <app-read-only-static
              [value]="publishedAt ? (publishedAt | dfnsParseIso | formatInTimeZone: dfnsLocale: 'mediumDate') : ''"
              label="{{'authenticated.quality-management.processes.edit.version_card.form.published_at.label' | translate }}"
            ></app-read-only-static>

            <app-form-group
              [formControl]="publishVersionForm.controls.change_description"
              type="textarea"
              label="{{'authenticated.quality-management.processes.edit.version_card.form.change_description.label' | translate }}"
              [errorMessages]="{required: ('authenticated.quality-management.processes.edit.version_card.form.change_description.validation_messages.required' | translate)}"
            ></app-form-group>

            @if (mode === EditModeEnum.EDIT) {
              <button
                [disabled]="!canBePublished"
                class="btn btn-primary"
              >{{ 'authenticated.quality-management.processes.edit.version_card.publish_version_btn' | translate }}
              </button>
            }
          </form>
        </div>

        @if (mode === EditModeEnum.EDIT) {
          <app-state-card
            [formControl]="form.controls.state"
            [omit]="[ModelStateEnum.DRAFT, ModelStateEnum.LOCKED]"
            [errorMessages]="{required: ('authenticated.quality-management.processes.edit.form.state.validation_messages.required' | translate)}"
          ></app-state-card>

          <app-delete-card
            [disabled]="!canBeDeleted"
            *appIfHasAnyPermissions="[PERMISSION.QUALITYMANAGEMENT_PROCESS_DELETE_ALL, {permission: PERMISSION.QUALITYMANAGEMENT_PROCESS_DELETE_ALL, modelId: process.id}]"
            itemName="{{ 'authenticated.quality-management.processes.delete.item' | translate }}"
            (deleteTriggered)="delete()"
          ></app-delete-card>
        }
      }
    </div>
  }
</div>
